<div
    class="indicator-values-component"
    [style]="{
        gap: this.isMobile() ? 'var(--spacing-12)' : 'var(--spacing-24)'
    }"
    fxLayout="row"
    fxLayoutAlign="{{ !isSpecialChart ? 'none center' : 'center center' }}"
>
    @for (comparation of seriesComparationsView(); track $index) {
        <div
            class="indicator-values-component_value"
            [style]="{
                width: this.isDrilldown ? '100%' : 'auto',
                maxWidth: this.isMobile() ? '150px' : 'none',
                gap: this.isDrilldown ? '2px' : 'var(--spacing-4)',
                display: $index > 2 && this.isMobile() ? 'none' : 'flex'
            }"
        >
            @if (
                seriesComparationsView().length <= 1 &&
                comparation.serieName !== visualization.props.name &&
                !isSpecialChart
            ) {
                <span
                    [class.text-12-semi-bold]="!isMobile()"
                    [class.text-10-semi-bold]="isMobile()"
                    [class.text-10-semi-bold]="visualization.PDFMode"
                    class="title indicator-color-cyan"
                    >{{ comparation.serieName }}
                    @if (visualization.options?.affiliate) {
                        - {{ visualization.options?.affiliate?.props.name }}
                    }
                </span>
            } @else if (!isSpecialChart) {
                <span
                    [class.text-12-semi-bold]="!isMobile()"
                    [class.text-10-semi-bold]="isMobile()"
                    [class.text-10-semi-bold]="visualization.PDFMode"
                    class="title indicator-color-cyan"
                    >{{ comparation.serieName }}</span
                >
            }
            @if (this.isDrilldown) {
                <span fxFlex></span>
            }

            @if (isSpecialChart) {
                <span
                    [class.h1-32-semi-bold]="!isMobile()"
                    [class.h1-24-semi-bold]="isMobile()"
                    [class.h1-24-bold]="visualization.PDFMode"
                    class="currency"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    [style.color]="currentValueColorByTheme"
                    [innerHTML]="comparation.currentValue"
                ></span>
            } @else {
                <span
                    [class.text-16-semi-bold]="!isMobile()"
                    [class.text-14-bold]="isMobile()"
                    [class.text-12-bold]="visualization.PDFMode"
                    class="currency"
                    [innerHTML]="comparation.currentValue"
                ></span>
            }

            @if (this.isDrilldown) {
                <span fxFlex></span>
            }
            <app-comparation-percentage-value
                fxLayout="column"
                fxLayoutAlign="{{
                    isSpecialChart ? 'center center' : 'none none'
                }}"
                [isSpecialChart]="isSpecialChart"
                [tooltip]="comparation.tooltip"
                [percentage]="comparation.percentage"
                [icon]="comparation.icon"
                [polarityColor]="comparation.polarityColor"
                [pdfMode]="visualization.PDFMode"
            ></app-comparation-percentage-value>
        </div>
    }
</div>
